module.exports = __webpack_public_path__ + "static/pic04-ca52fc550fc0e7c917da062e39dcc560.jpg";